import smartcaptureService from "../../../../services/web/smartcapture-service.js";
import {useQueries} from "@tanstack/react-query";
import lanesService from "../../../../services/web/lanes-service.js";
import {LaneTypeEnum} from "../utils/lanes-utils.js";

const QUERIES = [
  {
    key: "maintenanceGroup",
    enabledFlag: "maintenanceGroup",
    queryKey: ["maintenanceGroup"],
    queryFn: () => smartcaptureService.getPclMaintenanceGroupsOptions(),
    select: data => data.map(item => ({value: item.id, label: item.text}))
  },
  {
    key: "laneList",
    enabledFlag: "laneList",
    queryKey: ["laneList"],
    queryFn: () => lanesService.list(),
    select: data => data.map(item => {
      const newItem = { ...item };

      if (item.status && item.type === LaneTypeEnum.SMARTCAPTURE && (!item.smartCaptureDriver || !item.smartCapturePin)) {
        newItem.status = "alert";
      }

      switch (item.type) {
        case LaneTypeEnum.SMARTCAPTURE:
          newItem.type = "Smartcapture";
          break;
        case LaneTypeEnum.SENTRY_CLOUD:
          newItem.type = "Sentry Cloud";
          break;
        case LaneTypeEnum.MOBILE_APP:
          newItem.type = "App Captura Móvel";
          break;
        case LaneTypeEnum.MOBILE_CAMERA:
          newItem.type = "Móvel";
          break;
        case LaneTypeEnum.SIMULATOR:
          newItem.type = "Simulador";
          break;
      }

      return newItem;
    })
  },
  {
    key: "ftpUsers",
    enabledFlag: "ftpUsers",
    queryKey: ["ftpUsers"],
    queryFn: () => lanesService.getFtpUsers(),
  },
]

const useLanesFetch = (flags) => {
  const queries = useQueries({
    queries: QUERIES.map(item => ({
      queryKey: item.queryKey,
      queryFn: item.queryFn,
      enabled: !!flags[item.enabledFlag],
      ...(item.select && { select: item.select })
    }))
  });

  return QUERIES.reduce((acc, item, index) => {
    const query = queries[index];

    acc[item.key] = {
      data: query?.data ?? [],
      isLoading: query?.isLoading ?? false,
    }

    return acc
  }, {})
}

export default useLanesFetch;